import React, { useContext, useState, useEffect } from 'react'
import { Link, NavLink } from 'react-router-dom'
import AuthContext from '../../context/AuthContext'
import { apiGet } from '../../utils/apiFetch'
import apiPath from '../../utils/apiPath'
import Dashboard from '../../assets/images/sidebar_icon1.svg'
import Logout from '../../assets/images/logout.svg'
import { useTranslation } from 'react-i18next'
// Importing specific clean icons for parents and children
import { FaUsers, FaMoneyCheckAlt, FaFileInvoiceDollar, FaClipboardList, FaWallet } from 'react-icons/fa'

const classNames = require('classnames')

const AccountantSidebar = () => {
  const { t } = useTranslation()
  const { logoutUser, user, sidebarStatus, updatePageName } = useContext(AuthContext)
  // State to handle accordion collapse/expand
  const [openMenus, setOpenMenus] = useState({})
  
  // ─── NEW STATE FOR PAYROLL STATUS ───
  const [isPayrollActive, setIsPayrollActive] = useState(false)

  // ─── CHECK PAYROLL STATUS ON MOUNT ───
  useEffect(() => {
    const checkPayrollStatus = async () => {
      try {
        const res = await apiGet(apiPath.payrollStatus)
        // Check if it's active AND verified
        if (res?.data?.success && res.data.results?.isActive && res.data.results?.verifiedAt) {
          setIsPayrollActive(true)
        }
      } catch (error) {
        // Silently fail and keep it hidden if there's an error checking
        console.error("Failed to check payroll status in sidebar", error)
      }
    }
    
    // Only check if user is logged in
    if (user) {
      checkPayrollStatus()
    }
  }, [user])

  const toggleMenu = (menuKey) => {
    setOpenMenus(prev => ({
      ...prev,
      [menuKey]: !prev[menuKey]
    }))
  }

  const handleLogout = () => {
    if (window.confirm('Are you sure to logout?')) {
      logoutUser()
    }
  }

  const getNavLinkClassName = (isActive) =>
    classNames(
      'flex items-center px-4 lg:px-7 py-4 text-white active:text-LightBlue hover:bg-white hover:text-LightBlue transition-colors duration-200',
      {
        active: isActive
      }
    )

  return (
    <>
      <div
        className={`sidebar lg:block z-10  ${
          sidebarStatus === 'close' ? 'hideSideBar' : 'block'
        } bg-gradient-to-t from-gradpurple to-gradblue w-[220px] xl:w-[280px] fixed h-full overflow-y-auto`}
      >
        <div className='text-white'>
          <Link
            to='/dashboard'
            onClick={() => updatePageName('Dashboard')}
            className='px-2 py-6 w-full text-center flex justify-center'
          >
            <img src='./images/logo_white.png' className='inline' alt='' />
          </Link>
          <div className='profile text-center pb-4'>
            <small className='block text-sm'>Welcome Accountant</small>
            <strong className='block text-lg overflow-hidden text-ellipsis px-2 whitespace-nowrap '>
              {user?.name}
            </strong>
          </div>

          <nav className='pt-4 pb-5 flex flex-col justify-center font-normal text-xs overflow-y-auto'>
            
            <NavLink
              className={({ isActive }) => getNavLinkClassName(isActive)}
              onClick={() => updatePageName(t('NAV_DASHBOARD'))}
              to='/dashboard'
            >
              <span className='mr-2'>
                <img src={Dashboard} className='max-w-[18px]' alt='' />
              </span>
              {t('NAV_DASHBOARD')}
            </NavLink>

            <NavLink
              className={({ isActive }) => getNavLinkClassName(isActive)}
              onClick={() => updatePageName(t('Attendance Report'))}
              to='/all-employee-list'
            >
              <span className='mr-3 flex items-center justify-center'>
                <FaUsers className="w-5 h-5" />
              </span>
              {t('NAV_ALL_EMPLOYEE_LIST')}
            </NavLink>
                        <NavLink
              className={({ isActive }) => getNavLinkClassName(isActive)}
              onClick={() => updatePageName(t('Attendance Report'))}
              to='/attendance-report'
            >
              <span className='mr-3 flex items-center justify-center'>
                <FaClipboardList className="w-[18px] h-[18px]" />
              </span>
              {t('Attendance Report')}
            </NavLink>
            {isPayrollActive ? <NavLink
              className={({ isActive }) => getNavLinkClassName(isActive)}
              onClick={() => updatePageName(t('Attendance Report'))}
              to='/payroll-wages'
            >
              <span className='mr-3 flex items-center justify-center'>
                <FaWallet className="w-[18px] h-[18px]"/>
              </span>
              {t('Payroll')}
            </NavLink> : null}
            <Link
              onClick={handleLogout}
              className='flex items-center px-4 lg:px-7 py-4 text-white active:text-LightBlue hover:bg-white hover:text-LightBlue'
            >
              <span className='mr-2'>
                <img src={Logout} className='max-w-[18px]' alt='logout' />
              </span>
              {t('NAV_LOGOUT')}
            </Link>
          </nav>
        </div>
      </div>
    </>
  )
}

export default AccountantSidebar